<template>
    <div class="page-content header-clear-medium">

        <div class="card card-style" style="margin: 0px 15px 30px 15px;">
			<div class="content">
				<div class="row">
					<div class="col-12 col-md-4">
						<vc-date-picker 
							is-expanded 
							:max-date="maxDate"
							@dayclick="handleDayClick" 
							@update:to-page="updatePage" 
							:attributes='attributesVcCalendar' 
							:value="date"
						/>
					</div>

					<div class="col-12 col-md-4 mt-3">
						<h2 class="mb-3 text-sm-center"><span class="badge bg-blue-dark color-white">{{ currentDate | getDateIndoWithDay }}</span></h2>
						<h6 class="color-dark-light">Detail : </h6>
						
						<div :class="borderDetailDataPresence" class="d-flex border rounded p-2 cursor-pointer" @click="showDetailPresence">
							<div class="align-self-top me-3">
								<span :class="colorDetailDataPresence" class="icon icon-xxl color-white rounded-m"><i class="bi font-28" :class="classIconDetailDataPresence"></i></span>
							</div>
							<div>
								<h5 class="font-800">{{ textDetailDataPresence }}</h5>
								<p v-if="showHTimeDetailDataPresence" class="mt-0 mb-2 color-dark-light">
									Pada Jam {{ getTimeByPresenceData(objectDetailDataPresence.datetime) }}
								</p>
							</div>
						</div>

						<!-- <div class="d-flex">
							<div class="align-self-top me-3">
								<span 
									class="icon icon-xxl color-white rounded-m"
									:class="classIconDetailDataPresence"
								><i class="bi bi-calendar2-check-fill font-28"></i></span>
							</div>
							<div>
								<h5 class="font-800">Hadir di sekolah</h5>
								<p class="mt-0 mb-2 color-dark-light">
									Pada Jam 09:00
								</p>
							</div>
						</div>

						<div class="d-flex">
							<div class="align-self-top me-3">
								<span 
									class="icon icon-xxl bg-red-light color-white rounded-m"
									:class="classIconDetailDataPresence"
								><i class="bi bi-x-circle-fill font-28"></i></span>
							</div>
							<div>
								<h5 class="font-800">Tidak Hadir di sekolah</h5>
							</div>
						</div>

						<div class="d-flex">
							<div class="align-self-top me-3">
								<span class="icon icon-xxl bg-yellow-light color-white rounded-m"><i class="bi bi-exclamation-triangle-fill font-28"></i></span>
							</div>
							<div>
								<h5 class="font-800">Mengajukan Izin</h5>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>

		<Portal to="offcanvas-modal-bottom" :order="1">
            <div v-show="show_detail_presence" :data-bs-scroll="!show_detail_presence" data-bs-backdrop="false" class="offcanvas-custom offcanvas offcanvas-bottom rounded-m offcanvas-detached bg-theme show" style="visibility: visible;" id="offcanvas-tatib-detail">
                <div class="content">
                    <div class="d-flex pb-2">
                        <div class="align-self-center">
                            <h5 class="mb-n1 color-highlight font-700 text-uppercase pt-1 text-center">Detail Presensi</h5>
                            <!-- <h1 class="font-700">Share Duo</h1> -->
                        </div>
                        <div class="align-self-center ms-auto">
                            <a ref="hide-offcanvas-literacy-form" @click="hideDetailPresence" href="javascript:void(0)" class="icon icon-m"><i class="bi bi-x-circle-fill color-red-dark font-18 me-n4"></i></a>
                        </div>
                    </div>

					<h5 class="text-center">Presensi Geo Location</h5>

					<img :src="this.objectDetailDataPresence.link_google_drive" class="rounded mx-auto d-block mt-3" alt="Image Presensi">

					<div class="d-flex flex-row justify-content-center mt-3">
						<i class="bi bi-clock-fill color-blue-dark font-16"></i>
						<p class="font-16 ms-2"><strong>{{ this.objectDetailDataPresence.datetime | getDateIndoWithDayAndTime }}</strong></p>
					</div>
                </div>
            </div>

            <div v-show="show_detail_presence_backdrop" class="offcanvas-backdrop fade show"></div>
        </Portal>
        
    </div>
</template>

<script>
import { 
	// mapMutations, 
	mapActions, mapState 
} from 'vuex'
import moment from 'moment'

export default {
    name: 'Presence',
    components: {
    },
    data() {
        return {
			colorDetailDataPresence: {},
			borderDetailDataPresence: {},
			showHTimeDetailDataPresence: false,
			classIconDetailDataPresence: '',
			textDetailDataPresence: '',
			objectDetailDataPresence: {},

			maxDate: moment().format('YYYY-MM-DD'),
			currentDate: moment().format('YYYY-MM-DD'),

			date : new Date(),
			attributesVcCalendar: [],

			show_detail_presence: false,
            show_detail_presence_backdrop: false,
			selectedPresenceDetail: {},
        }
    },
    async created() {
        this.handleGetPresencesByDate(this.maxDate)
    },
    methods: {
        // ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
        ...mapActions('presence', ['getPresencesByMonth', 'getPresencesByDate']),
		// getDetailPresenceByDate() {
		// 	this.getPresencesDetail(this.presenceDate)
		// },
		getTimeByPresenceData(datetime) {
			return moment(datetime, "YYYY-MM-DD HH:mm:ss").format('HH:mm')
		},
		handleDayClick(date) {
			if (moment(date.id, "YYYY-MM-DD").isSameOrBefore(this.maxDate)) {
				this.handleGetPresencesByDate(date.id)
				this.currentDate = date.id
			}
		},
		async handleGetPresencesByDate(date) {
			let dataPresenceByDate = await this.getPresencesByDate(date)
			this.currentDate = date
			if (Object.prototype.hasOwnProperty.call(dataPresenceByDate.data, "Tidak Masuk")) {
				this.colorDetailDataPresence = { 'bg-red-light': true }
				this.borderDetailDataPresence = { 'border-red-light': true }
				this.showHTimeDetailDataPresence = false
				this.classIconDetailDataPresence = 'bi-x-circle-fill'
				this.textDetailDataPresence = 'Tidak Hadir di sekolah'
			} else if (Object.prototype.hasOwnProperty.call(dataPresenceByDate.data, "Dispensasi") || Object.prototype.hasOwnProperty.call(dataPresenceByDate.data, "Sakit") || Object.prototype.hasOwnProperty.call(dataPresenceByDate.data, "Izin")) {
				this.colorDetailDataPresence = { 'bg-yellow-light': true }
				this.borderDetailDataPresence = { 'border-yellow-light': true }
				this.showHTimeDetailDataPresence = true
				this.classIconDetailDataPresence = 'bi-exclamation-triangle-fill'
				if (Object.prototype.hasOwnProperty.call(dataPresenceByDate.data, "Dispensasi")) {
					this.textDetailDataPresence = 'Dispensasi'
					this.objectDetailDataPresence = dataPresenceByDate.data['Dispensasi']
				} else if (Object.prototype.hasOwnProperty.call(dataPresenceByDate.data, "Sakit")) {
					this.textDetailDataPresence = 'Sakit'
					this.objectDetailDataPresence = dataPresenceByDate.data['Sakit']
				} else {
					this.textDetailDataPresence = 'Izin'
					this.objectDetailDataPresence = dataPresenceByDate.data['Izin']
				}
			} else if (Object.prototype.hasOwnProperty.call(dataPresenceByDate.data, "masuk") && dataPresenceByDate.data.masuk == "Libur") {
				this.colorDetailDataPresence = { 'bg-red-light': true }
				this.borderDetailDataPresence = { 'border-red-light': true }
				this.showHTimeDetailDataPresence = false
				this.classIconDetailDataPresence = 'bi-x-circle-fill'
				this.textDetailDataPresence = 'Libur'
			} else {
				this.colorDetailDataPresence = { 'bg-green-light': true }
				this.borderDetailDataPresence = { 'border-green-light': true }
				this.showHTimeDetailDataPresence = true
				this.classIconDetailDataPresence = 'bi-calendar2-check-fill'
				this.textDetailDataPresence = 'Hadir di sekolah'
				this.objectDetailDataPresence = dataPresenceByDate.data['masuk']
			}
		},
		async updatePage(fromPage) {
			console.log(fromPage)
			let tempAttributesVcCalendar = []
			let dataPresenceByMonth = await this.getPresencesByMonth(fromPage)
			for (let datePresence in dataPresenceByMonth.data) {
				// console.log(`${property}: ${object[property]}`);
				// console.log(datePresence, dataPresenceByMonth.data[datePresence])
				let dateDate = `${fromPage.year}-${String(fromPage.month).padStart(2, '0')}-${datePresence.padStart(2, '0')}`
				if (moment(dateDate, "YYYY-MM-DD").isSameOrBefore(this.maxDate)) {
					let tempAttributeCalendar = {}
					let tempDataPresenceByMonth = dataPresenceByMonth.data[datePresence]
					if (Object.prototype.hasOwnProperty.call(tempDataPresenceByMonth, "Tidak Masuk")) {
						if (moment().isSame(dateDate, 'day')) {
							tempAttributeCalendar = {
								highlight: {
									color: 'red',
									fillMode: 'outline',
									contentClass: 'text-danger',
								},
								dates: dateDate
							}
						} else {
							tempAttributeCalendar = {
								highlight: {
									color: 'red',
									fillMode: 'solid',
									contentClass: 'text-white',
								},
								dates: dateDate
							}
						}
					} else if (Object.prototype.hasOwnProperty.call(tempDataPresenceByMonth, "Dispensasi") || Object.prototype.hasOwnProperty.call(tempDataPresenceByMonth, "Sakit") || Object.prototype.hasOwnProperty.call(tempDataPresenceByMonth, "Izin")) {
						if (moment().isSame(dateDate, 'day')) {
							tempAttributeCalendar = {
								highlight: {
									color: 'orange',
									fillMode: 'outline',
									contentClass: 'text-warning',
								},
								dates: dateDate
							}
						} else {
							tempAttributeCalendar = {
								highlight: {
									color: 'orange',
									fillMode: 'solid',
									contentClass: 'text-white',
								},
								dates: dateDate
							}
						}
					} else {
						if (Object.prototype.hasOwnProperty.call(tempDataPresenceByMonth, "masuk") && tempDataPresenceByMonth.masuk == "Libur") {
							tempAttributeCalendar = {
								highlight: {
									// color: 'purple',
									// fillMode: 'solid',
									contentClass: 'text-danger',
								},
								dates: dateDate
							}
						} else {
							if (moment().isSame(dateDate, 'day')) {
								tempAttributeCalendar = {
									highlight: {
										color: 'green',
										fillMode: 'outline',
										contentClass: 'text-success',
									},
									dates: dateDate
								}
							} else {
								tempAttributeCalendar = {
									highlight: {
										color: 'green',
										fillMode: 'solid',
										contentClass: 'text-white',
									},
									dates: dateDate
								}
							}
						}
					}
	
					tempAttributesVcCalendar.push(tempAttributeCalendar)
				}

			}
			// alert('update to page')
			this.attributesVcCalendar = tempAttributesVcCalendar
		},
		showDetailPresence() {
			if (this.objectDetailDataPresence.send_presence == 'api') {
				this.show_detail_presence = true
				this.show_detail_presence_backdrop = true
			}
        },
		hideDetailPresence() {
            this.show_detail_presence = false
            this.show_detail_presence_backdrop = false
        },
    },
    computed: {
        // ...mapState({
        //     loading: state => state.loading
        // }),
        ...mapState('presence', {
            presences_by_month: state => state.presences_by_month
        }),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
</style>
